import { render, staticRenderFns } from "./int5.vue?vue&type=template&id=07848102&scoped=true&"
import script from "./int5.vue?vue&type=script&lang=js&"
export * from "./int5.vue?vue&type=script&lang=js&"
import style0 from "./int5.vue?vue&type=style&index=0&id=07848102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07848102",
  null
  
)

export default component.exports